module.exports = __webpack_public_path__ + "img/video-bg.f2ce74f2.png";